import { multiplayer, PlayerProfile } from "@/multiplayer";
import { useEffect, useRef } from "react";
import { usePlayerStore } from "../stores/usePlayerStore";
import { eventHandlers } from "@/lib/utils";

export function usePlayerManagement(playerProfile: PlayerProfile) {
	const playerList = useRef<PlayerProfile[]>([]);
	const handlePlayerListSnapshot = usePlayerStore((state) => state.handlePlayerListSnapshot);

	useEffect(() => eventHandlers(
		multiplayer.packets.on("player:list", (newPlayerList) => {
			handlePlayerListSnapshot(newPlayerList);
		}),
		multiplayer.on("hosted", () => {
			multiplayer.send("player:register", playerProfile, 'localOnly')
		}),
		multiplayer.on("joined", () => {
			multiplayer.send("player:register", playerProfile, "remoteOnly")
		}),
		multiplayer.packets.on("player:register", (newPlayer) => {
			playerList.current = [...playerList.current, newPlayer];
			multiplayer.send("player:list", playerList.current, "both");
		}),
	), [handlePlayerListSnapshot, playerProfile])
}